import React, { useEffect } from "react";
import HoneycombGrid from "../base/Honeycomb";
import { Box, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import DashboardHeaderView from "../views/Dashboard/DashboardHeaderView";
import { useDispatch, useSelector } from "../../store";
import {
  getDashboardDetail,
  setCurrentDashboard,
} from "../../slices/dashboard";
import { handleReload } from "../../slices/shared";
import { clearLoadingState } from "../../slices/tile";

interface Props {}

const DashboardPage: React.FC<Props> = (props) => {
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { homeDashboard, currentDashboard } = useSelector(
    (store) => store.dashboard
  );
  const { globalLoadingState } = useSelector((store) => store.shared);

  useEffect(() => {
    if (!!id) {
      if (!currentDashboard || currentDashboard.id !== +id!) {
        dispatch(getDashboardDetail(+id!));
      }
    } else {
      if (!!homeDashboard && currentDashboard?.id !== homeDashboard.id) {
        dispatch(setCurrentDashboard(homeDashboard));
      } else {
        navigate("/dashboard");
      }
    }
  }, [dispatch, id, homeDashboard, currentDashboard, navigate]);

  useEffect(() => {
    const loadTiles = () => {
      dispatch(handleReload(currentDashboard?.tiles?.map((x) => x.id)));
    };

    loadTiles();

    const interval = setInterval(loadTiles, 5000);

    return () => {
      clearInterval(interval);
      dispatch(clearLoadingState({}));
    };
  }, [currentDashboard?.tiles, dispatch]);

  return (
    <Box paddingTop={2} paddingBottom={5} display="flex" flexDirection="column">
      {currentDashboard! ? (
        <>
          <DashboardHeaderView id={currentDashboard?.id!} />
          {!!currentDashboard && currentDashboard.tiles && (
            <HoneycombGrid tiles={currentDashboard.tiles} />
          )}
        </>
      ) : (
        !homeDashboard &&
        !globalLoadingState.isLoading && (
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            marginX={5}
            height="20px"
          >
            <Typography>No home dashboard selected!</Typography>
          </Box>
        )
      )}
    </Box>
  );
};

export default DashboardPage;
